import React, { FC } from "react";
import { useTranslation } from "react-i18next";

/**
 * Bonus plan option shown in the bonus popup. The legacy styling props
 * (customClass, pointClass, paymentClass ...) are still accepted so existing
 * callers compile, but the card now takes its look from the design system;
 * use `featured` to emphasise a plan.
 */
export interface ICard {
  Redeem: any;
  SelectPoints: any;
  points?: any;
  customClass?: any;
  payment?: any;
  pointClass?: any;
  paymentClass?: any;
  RedeemClass?: any;
  FromPoints?: any;
  selectPointClass?: any;
  payClass?: any;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onClickSelectPoints: () => void;
  disabled: boolean;
  /** Highlighted plan (hovered or default recommendation). */
  featured?: boolean;
}

export const BonusCard: FC<ICard> = ({
  Redeem,
  SelectPoints,
  points,
  payment,
  FromPoints,
  onClickSelectPoints,
  disabled,
  onMouseEnter,
  onMouseLeave,
  featured = false,
}) => {
  const { t } = useTranslation();
  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`flex flex-col items-center gap-4 p-5 text-center border rounded-lg transition-colors duration-200 ${
        featured ? "border-primary bg-primary-soft ring-1 ring-primary shadow-sm" : "border-line bg-surface"
      }`}
    >
      <span className={`zs-badge ${featured ? "zs-badge-primary" : ""}`}>{payment}</span>

      <div className="flex flex-col items-center">
        <span className="text-4xl font-bold leading-none tracking-tight font-display tabular-nums text-ink">
          {points}
        </span>
        <span className="mt-1 text-xs font-medium tracking-wide uppercase text-ink-3">{t("bonus.card.Points")}</span>
      </div>

      <div className="flex flex-col gap-0.5 text-sm">
        <span className="font-medium text-ink-2">{Redeem}</span>
        <span className="text-xs text-ink-3">{FromPoints}</span>
      </div>

      <button
        onClick={onClickSelectPoints}
        disabled={disabled}
        className={`zs-btn zs-btn-block mt-auto ${featured ? "zs-btn-primary" : "zs-btn-secondary"}`}
      >
        {SelectPoints}
      </button>
    </div>
  );
};
